import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';

export const LocationBreadcrumbs = ({
  businessData,
  children,
  locationData,
}) => {
  // base location breadcrumbs
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <div className="sb-main-breadcrumbs">
      <ul className="sb-flex">
        {globals.visible.projectsView && (
          <li className="sb-flex">
            <Link to={`/dashboard/projects`}>Projects</Link>
            <ChevronRightIcon />
          </li>
        )}
        <li className="sb-flex">
          {!businessData && <span>...</span>}
          {businessData && (
            <Link to={`/dashboard/projects/${businessData.id}`}>
              {businessData.business_name}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        <li className="sb-flex">
          {!businessData && <span>...</span>}
          {businessData && (
            <Link to={`/dashboard/projects/${businessData.id}/locations`}>
              {t('Location details')}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        <li className="sb-flex">
          {!locationData && <span>...</span>}
          {locationData && (
            <Link
              to={`/dashboard/projects/${businessData.id}/locations/${locationData.id}`}
            >
              {locationData.location_name || locationData.street}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        {children}
      </ul>
    </div>
  );
};
